exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.swiper-slide[data-v-78b7a345] {\n  background-color: rgba(0, 0, 0, 0);\n  visibility: inherit;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: auto !important;\n  vertical-align: middle;\n  width: 128px;\n}\n.social img[data-v-78b7a345] {\n  width: 23px;\n  height: 23px;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
